import React, {useState} from 'react';
import {
  AppBar,
  Avatar,
  createStyles,
  Hidden,
  IconButton,
  MenuItem,
  Theme,
  Tooltip,
  Select,
  Radio,
  ListItemText,
  Button
} from '@material-ui/core';

import NotificationsNoneIcon from '@material-ui/icons/Message';

import {Permission} from '@shared/services/PermissionService';
import {
  AppPermissions,
  CCMConstants,
  ORGANIZATION_GROUP_TYPES,
  PriorAuthConstants
} from '@shared/constants/Mapping';

// import {Menu as MenuIcon} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import {connect, useDispatch, useSelector} from 'react-redux';
import {Trans, useTranslation} from 'react-i18next';
import {
  APP_PRIMARY_COLOR,
  BORDER_PRIMARY_COLOR,
  DEFAULT_WHITE_COLOR
} from '../../../style/variable';
import CustomPopOver, {
  CustomPopOverListItemType
} from '@components/system/CustomPopOver/CustomPopOver';
import {useHistory} from 'react-router-dom';
import {
  _groupId,
  _logout,
  _showMessageAlert
} from '@shared/store/actions/AuthActions';
import NavRoutes from '../../../constants/route/NavRoutes';
import StyledTabs from '@components/system/Tabs/StyledTabs';
import StyledTab from '@components/system/Tabs/StyledTab';
import {APP} from '../../../style/variable';
import MedopsLogo from '../MyIcons/MedopsLogo';
import HelperUtils from '@shared/utils/HelperUtils';
import {UserTypes} from '@shared/constants/Mapping';
import StyledSelectInput from '../FormInput/StyledSelectInput';
import {
  _patientsShared,
  _statementsSelectedClinic,
  _groupType
} from '@shared/store/actions/ClinicActions';
import {environment} from '@shared/environment/environment';
import LaunchIcon from '@material-ui/icons/Launch';
// import {BASE_ROUTE_ADMIN} from 'src/constants/route/BaseRoute';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import CustomBadge from 'src/modules/admin/modules/Home/CustomBadge';
import {BASE_ROUTE_ADMIN} from 'src/constants/route/BaseRoute';
import {logoutUserFromWeb} from '@shared/services/CommonServices';
import {_setMessageTabOptions} from '@shared/store/actions/NewMessagesActions';
import {_resetGroupState} from '@shared/store/actions/GroupActions';
import Timer from 'src/modules/admin/modules/ChronicCareManagement/module-components/TimeTracker/Timer';
import WarningTimerDialog from 'src/modules/admin/modules/ChronicCareManagement/module-components/StopTimerDialog/WarningTimerDialog';
import Storage from 'src/utils/Storage';
import StopTimerDialog from 'src/modules/admin/modules/ChronicCareManagement/module-components/StopTimerDialog/StopTimerDialog';
import {
  _ccmSinglePatientDetails,
  _generateDOBForCCMUserRole
} from '@shared/store/actions/CCMTimerActions';
import StopTicketTimerDialog from 'src/modules/admin/modules/TicketingSystem/TicketingSystemTimer/StopTicketTimerDialog/StopTicketTimerDialog';
import InitSharedRepo from '../../../../../shared';

// import {AppPermissions} from '@shared/constants/Mapping';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiTabScrollButton-root': {
        display: 'none'
      }
    },
    menuButton: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        display: 'none'
      }
    },
    toolTip: {
      fontSize: '0.9rem',
      lineHeight: '1.5'
    },
    ClinicMenu: {
      overflow: 'auto',
      '& li': {
        paddingTop: '3px',
        paddingBottom: '3px',
        borderBottom: `1px solid ${BORDER_PRIMARY_COLOR}`
      },
      '& li:last-child': {
        paddingTop: '3px',
        paddingBottom: '3px',
        borderBottom: 'none'
      }
    },
    toolbarStyle: {
      paddingLeft: '0',
      marginRight: '2.8rem'
    },
    toolbar: theme.mixins.toolbar,
    appIconWidth: {
      cursor: 'pointer',
      display: 'flex',
      padding: '0 12px',
      alignItems: 'center'
    },
    appIconLogo: {
      maxHeight: '29px',
      maxWidth: '150px'
    },
    iconWrapper: {
      // flexGrow: 1,
      paddingRight: theme.spacing(2),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end'
    },
    title: {
      fontSize: '2rem',
      color: theme.palette.common.white,
      fontFamily: APP.FONT_FAMILY.REGULAR,
      fontWeight: 1000,
      letterSpacing: 2
    },
    notificationButtonView: {
      marginRight: '1rem'
    },
    notificationIcon: {
      height: '1.5rem',
      width: '1.5rem'
    },
    profileIcon: {
      height: '3rem',
      width: '3rem'
    },
    logo: {
      height: '5rem',
      width: '10rem'
    },
    blue: {
      color: APP_PRIMARY_COLOR,
      backgroundColor: DEFAULT_WHITE_COLOR,
      height: '26px',
      width: '26px',
      fontSize: '0.8rem'
    },
    buttonPadding: {
      padding: '5px'
    },
    dropDownWrapper: {
      padding: '0 0 0 8px',
      '@media (min-width:900px) and (max-width:999px)': {
        padding: '0 0 0 16px'
      },
      '@media (min-width:1000px)': {
        padding: '0 0 0 48px'
      },
      '@media (max-width:600px)': {
        minWidth: '9.5rem',
        maxWidth: '11.5rem',
        position: 'relative',
        left: '30px'
      },
      '@media (min-width:601px) and (max-width: 799px)': {
        minWidth: '10.5rem',
        maxWidth: '12.5rem'
      },
      '@media (min-width:800px) and (max-width: 849px)': {
        minWidth: '12.5rem',
        maxWidth: '14.5rem'
      },
      '@media (min-width:850px) and (max-width: 899px)': {
        minWidth: '13.5rem',
        maxWidth: '15.5rem'
      },
      '@media (min-width:900px) and (max-width: 1000px)': {
        minWidth: '14.5rem',
        maxWidth: '16.5rem'
      },
      '@media (min-width:1001px) and (max-width: 1049px)': {
        minWidth: '14.5rem',
        maxWidth: '16.5rem'
      },
      '@media (min-width:1050px) and (max-width: 1100px)': {
        minWidth: '15.5rem',
        maxWidth: '17.5rem'
      },
      '@media (min-width:1101px) and (max-width: 1199px)': {
        minWidth: '16.5rem',
        maxWidth: '18.5rem'
      },
      '@media (min-width:1200px)': {
        minWidth: '17.0rem',
        maxWidth: '19.0rem'
      }
    },
    name: {
      width: '8rem',
      wordWrap: 'break-word',
      textAlign: 'right',
      margin: '0 7px 0 12px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      display: 'inline-block'
    },
    userGroups: {
      maxHeight: '2.2rem',
      overflowY: 'hidden',
      '@media (min-width:300px) and (max-width:399px)': {
        minWidth: '6.0rem',
        maxWidth: '7.0rem'
      },
      '@media (min-width:400px) and (max-width:499px)': {
        minWidth: '7.0rem',
        maxWidth: '8.0rem'
      },
      '@media (min-width:500px) and (max-width:599px)': {
        minWidth: '8.0rem',
        maxWidth: '9.0rem'
      },
      '@media (min-width:600px) and (max-width:699px)': {
        minWidth: '9.0rem',
        maxWidth: '10.0rem'
      },
      '@media (min-width:700px) and (max-width: 799px)': {
        minWidth: '11.0rem',
        maxWidth: '12.0rem'
      },
      '@media (min-width:800px)': {
        minWidth: '12.0rem',
        maxWidth: '13.0rem'
      },
      '& .MuiSvgIcon-root': {
        color: APP_PRIMARY_COLOR
      },
      backgroundColor: DEFAULT_WHITE_COLOR
    },
    Menu: {
      alignItems: 'center',
      width: '100%',
      marginLeft: '1rem',
      justifyContent: 'space-evenly',
      height: theme.mixins.toolbar.minHeight
    },
    titleMenu: {
      fontSize: '1.1rem',
      color: DEFAULT_WHITE_COLOR
    },
    Arrow: {
      position: 'relative',
      color: DEFAULT_WHITE_COLOR,
      width: '1.5em',
      height: '2em'
    },
    MenupopOver: {
      position: 'absolute',
      left: '3.5rem',
      top: '0rem',
      '& p': {
        // targetting first span element inside a paragraph element to create spacing between custom bage and label
        '& span': {
          marginLeft: '0.3rem'
        },
        overflow: 'visible !important' as any
      }
    },
    profileMenuPopOver: {
      position: 'absolute',
      left: '0rem',
      top: '0.2rem'
    },
    badgeWrapper: {
      position: 'relative',
      top: '-9px',
      right: '-5px'
    },
    customBadge: {
      position: 'relative',
      top: '7px',
      left: '7px'
    },
    notificationsIcon: {
      padding: '8px',
      display: 'flex',
      cursor: 'pointer',
      marginRight: '0 0.5rem'
    },
    tabMargin: {
      marginLeft: '1rem'
    },
    tabsAndMenuView: {
      display: 'flex',
      alignItems: 'center',
      height: theme.mixins.toolbar.minHeight
    },
    mainWrap: {
      display: 'flex',
      cursor: 'pointer'
    },
    menuPopOver: {
      // This is to remove the scroll bar in Menu PopOver
      '& .MuiList-root > div': {
        maxHeight: 'max-content'
      }
    }
  })
);

interface TopAppBarProps {
  className?: string;
  handleDrawerToggle(): void;
  tabValue: number;
  tabs: Array<string>;
  handleTabChange(event: React.ChangeEvent<any>, tabId: number): void;
  initialRoute?: any; // coming from redux
  logout?(): void; // coming from redux,
  _initUserInfo?: any; // coming from redux,
  user?: any;
  groupId?: string | number;
  userGroups?: any[];
  userType?: string;
  handleRoute(item: any): any;
  list: any;
  handleLoader?: any;
}

const TopAppBar = (props: TopAppBarProps): React.ReactElement => {
  const {t} = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    className,
    // handleDrawerToggle,
    handleTabChange,
    tabs,
    tabValue,
    user = {},
    // FIXME: Will it be an empty object
    groupId = {},
    userGroups = [],
    userType,
    handleRoute,
    list,
    handleLoader
  } = props;
  const [open, setOpen] = React.useState(false);
  const [arrowUp, setArrowUp] = React.useState(false);
  const [toolTipOpen, setToolTipOpen] = React.useState(false);
  const [opened, setOpened] = useState(false);
  const [selectedGroup, setSelectedGroup] = React.useState<any>({});

  // Show the warning dialog if we try to log out of the app while the timer is still active.
  // and stop timer dialog and then logout from the app for this one maintaing below states
  const [showStopTimerWarningDialog, setShowStopTimerWarningDialog] = useState(
    false
  );
  const [
    showStopTicketTimerWarningDialog,
    setShowStopTicketTimerWarningDialog
  ] = useState(false);

  const [
    showStopSwitchGroupTicketTimerWarningDialog,
    setShowSwitchGroupStopTicketTimerWarningDialog
  ] = useState(false);
  const [showLogoutStopTimerDialog, setShowLogoutStopTimerDialog] = useState(
    false
  );
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const menuAnchorRef = React.useRef<HTMLButtonElement>(null);

  const initialRoute = useSelector((state: any) => state.auth.initialRoute);
  const count = useSelector((state: any) => state.newMessages.count);
  const userPermissions = useSelector(
    (state: any) => state.auth.userPermissions
  );
  const groupType = useSelector((state: any) => state.clinics.groupType);
  const id = useSelector((state: any) => state.auth.groupId);
  const {
    isTimerRunning: ccmIsRunning,
    ccmPatientId,
    patientName,
    accountNumber,
    isSinglePatientSearch
  } = useSelector((state: any) => state.ccmTimer);

  // ** Reading Ticket Timer details from redux and setting it up */
  const {isTicketTimerRunning} = useSelector(
    (state: any) => state.PriorAuthTicketTimer
  );

  // ** Readig the running ticket details from the local storage */
  let localStorageData: any = Storage.getItem(
    PriorAuthConstants.STORAGE_PRIOR_AUTH_TIMER_DATA
  );
  if (localStorageData) {
    localStorageData = JSON?.parse?.(localStorageData);
  }

  const [navigateToGroup, setNavigateToGroup] = useState<any>(null);

  React.useEffect(() => {
    if (userGroups.length) {
      setSelectedGroup(
        userGroups.find((userGroup: any) => userGroup.id == groupId) ?? {}
      );
    }
  }, [groupId, userGroups]);

  const handleMenuProfile = () => {
    setOpened(true);
    setArrowUp(true);
    dispatch(_ccmSinglePatientDetails(ccmPatientId, '', null, false));
  };

  const MenuhandleClose = () => {
    setOpened(false);
    setArrowUp(false);
  };

  const handlePopOverItemClicks = (item: CustomPopOverListItemType) => {
    handleRoute(item);
    dispatch(_showMessageAlert(false));
  };

  const renderMenuPopovers = (): React.ReactElement => {
    return (
      <span className={classes.MenupopOver}>
        <CustomPopOver
          open={opened}
          anchorEl={menuAnchorRef.current}
          listItems={list}
          position="bottom"
          handleClose={MenuhandleClose}
          handleListItemClick={handlePopOverItemClicks}
          className={classes.menuPopOver}
        />
      </span>
    );
  };

  const popOverItems: Array<CustomPopOverListItemType> = [
    {name: t('TOP_NAV_COMMON.PROFILE'), id: 'PROFILE'},
    {name: t('TOP_NAV_COMMON.CHANGE_PASSWORD'), id: 'RESET'},
    {
      name: t('TOP_NAV_COMMON.DOC_URL'),
      id: 'DOC_URL',
      icon: <LaunchIcon fontSize="small" color="primary" />
    },
    {name: t('TOP_NAV_COMMON.LOGOUT'), id: 'LOGOUT'}
  ];

  const handleClose = () => {
    setOpen(false);
  };

  const handleToggleProfile = () => {
    setOpen(true);
  };

  const handleParentTimeStart = () => {
    // checking whether the timer is running for atleast one patient or not and redirecting to CCM tab //
    if (!isSinglePatientSearch) {
      const CCMObject = {
        name: AppPermissions.CCM.NAME,
        id: 'CCM',
        route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.CCM}/${NavRoutes.PRIVATE.ADMIN.CCM_TABS.PATIENTS}`,
        label: t('TOP_NAV_COMMON.TABS.CCM')
      };

      //  FIXME: Better move this state to the redux
      let timerGroupId: any;

      const storedTimerData = Storage.getItem(
        CCMConstants.STORAGE_CCM_TIMER_DATA
      );
      if (storedTimerData) {
        const parsedTimerData = JSON.parse(storedTimerData);
        timerGroupId = parsedTimerData?.groupId;
      }

      if (timerGroupId != groupId || !ccmIsRunning) {
        handleRoute(CCMObject);
      }
    }
  };

  const closeStopTimerWarningDialog = () => {
    setShowStopTimerWarningDialog(false);
    // setShowLogoutStopTimerDialog(false);
  };

  const myProfilePage = () => {
    handleClose();
    history.replace(`/${initialRoute}/home/profile`);
  };
  const resetPassword = () => {
    handleClose();
    history.replace(`/${initialRoute}/home/changepassword`);
  };

  const logoutFromApp = async () => {
    try {
      await logoutUserFromWeb();
      history.push(`/${NavRoutes.PUBLIC.LOGOUT}`);
    } catch (error) {
      history.push(`/${NavRoutes.PUBLIC.LOGOUT}`);
    }
  };

  // ticket timer warning dialog //
  const handleShowStopTicketTimerWarningDialog = () => {
    setShowStopTicketTimerWarningDialog(true);
  };

  const handleLogout = async () => {
    dispatch(_generateDOBForCCMUserRole(null));
    if (ccmIsRunning) {
      setShowStopTimerWarningDialog(true);
    } else if (isTicketTimerRunning) {
      handleShowStopTicketTimerWarningDialog();
    } else {
      logoutFromApp();
    }
  };

  const handleStopTimer = () => {
    setShowStopTimerWarningDialog(false);
    setShowLogoutStopTimerDialog(true);
  };

  const goToDocWebsite = () => {
    handleClose();
    window.open(environment.docUrl, '_blank', 'noopener,noreferrer');
  };

  const handlePopOverItemClick = (item: CustomPopOverListItemType) => {
    if (item.id === 'LOGOUT') {
      handleLogout();
    } else if (item.id === 'PROFILE') {
      myProfilePage();
    } else if (item.id === 'DOC_URL') {
      goToDocWebsite();
    } else {
      if (item.id === 'RESET') {
        resetPassword();
      }
    }
  };

  const renderPopover = (): React.ReactElement => {
    return (
      <span className={classes.profileMenuPopOver}>
        <CustomPopOver
          open={open}
          anchorEl={anchorRef.current}
          listItems={popOverItems}
          position="bottom-end"
          handleClose={handleClose}
          handleListItemClick={handlePopOverItemClick}
        />
      </span>
    );
  };

  const isCCMTimerRunning = useSelector(
    (state: any) => state.ccmTimer.isTimerRunning
  );

  const [openDialogs, setOpenDialogs] = useState({
    stopTimerDialog: false,
    stopTimerWarningDialog: false,
    stopTicketTimerDialog: false
  });

  const handleShowStopTimerWarningDialog = () => {
    setOpenDialogs(p => ({
      ...p,
      stopTimerWarningDialog: true
    }));
  };

  // ** Ticket Timer Warning dialog funtions  start */

  // **below is the function use to close the ticket timer warning dialog when logging out of the application */
  const handleCloseStopTicketTimerWarningDialog = () => {
    setShowStopTicketTimerWarningDialog(false);
  };

  // ** open the ticket timer warning dialog when switching between groups */
  const handleShowSwitchGroupStopTicketTimerWarningDialog = () => {
    setShowSwitchGroupStopTicketTimerWarningDialog(true);
  };

  // ** close the ticket timer warning dialog when switching between groups // */
  const handleCloseSwitchGroupStopTicketTimerWarningDialog = () => {
    setShowSwitchGroupStopTicketTimerWarningDialog(false);
  };

  // when clicked on the save button in the warning dialog this function executes to open the stop ticket timer dialog //
  const handleShowStopTicketTimerDialog = () => {
    setOpenDialogs(p => ({
      ...p,
      stopTicketTimerDialog: true
    }));
  };
  // ** Ticket Timer Warning dialog functions end */

  const handleCloseStopTimerWarningDialog = () => {
    setOpenDialogs(p => ({
      ...p,
      stopTimerWarningDialog: false
    }));
  };
  const handleShowStopTimerDialog = () => {
    setOpenDialogs(p => ({
      ...p,
      stopTimerDialog: true
    }));
  };
  const handleCloseStopTimerDialog = () => {
    setOpenDialogs(p => ({
      ...p,
      stopTimerDialog: false
    }));
  };

  const renderStopCCMTimerRunningWarningDialog = () => {
    let storagePatientName = '';
    const storedTimerData = Storage.getItem(
      CCMConstants.STORAGE_CCM_TIMER_DATA
    );
    if (storedTimerData) {
      const parsedTimerData = JSON.parse(storedTimerData);
      storagePatientName = parsedTimerData?.patientName;
    }
    return (
      openDialogs.stopTimerWarningDialog && (
        <WarningTimerDialog
          open={openDialogs.stopTimerWarningDialog}
          onClose={handleCloseStopTimerWarningDialog}
          onSave={handleShowStopTimerDialog}
          titleHeader={t('CCM.WARNING.DIALOG_HEADER')}
          contentBody={
            <Trans
              i18nKey={'CCM.WARNING.ALERT_CHANGE_GROUP_STOP_TIMER'}
              values={{
                patient_name: storagePatientName
              }}
              components={[<strong key={'X'} />]}
            />
          }
          cancelBtnText={t('COMMON.NO')}
          confirmBtnText={t('COMMON.YES')}
        />
      )
    );
  };

  // ** Warning dialog while switching between groups while timer is running for a ticket  start //
  const renderGroupSwitchTicketTimerWarningPrompt = () => {
    return (
      showStopSwitchGroupTicketTimerWarningDialog && (
        <WarningTimerDialog
          open={showStopSwitchGroupTicketTimerWarningDialog}
          onClose={handleCloseSwitchGroupStopTicketTimerWarningDialog}
          onSave={() => handleShowStopTicketTimerDialog()}
          titleHeader={t('TICKETING_SYSTEM.TIMER.WARNING_DIALOG.ALERT_HEADER')}
          contentBody={
            <Trans
              i18nKey={
                'TICKETING_SYSTEM.TIMER.WARNING_DIALOG.ALERT_CHANGE_GROUP_STOP_TICKET_TIMER'
              }
              values={{
                patient_name: localStorageData?.ticketPanelData?.patientName
              }}
              components={[<strong key={'X'} />]}
            />
          }
          cancelBtnText={t('COMMON.NO')}
          confirmBtnText={t('COMMON.YES')}
        />
      )
    );
  };
  // ** Warning dialog while switching between groups while timer is running for a ticket  end //

  const handleSwitchGroup = (userGroup: any) => {
    if (selectedGroup.id !== userGroup.id) {
      // CLEARING THE MESSAGE TAB OPTIONS OF PREVIOUS GROUP
      dispatch(_setMessageTabOptions({}));
      // SETTING UP CLINIC DETAILS EMPTY IN REDUX STATE
      dispatch(_statementsSelectedClinic([], [], '', ''));
      // SETTING UP NEW CLINIC GROUP DETAILS TO STATE
      setSelectedGroup(userGroup);
      // SETTING UP NEW GROUP ID TO REDUX
      dispatch(_groupId(userGroup.id));

      // SETTING THE GROUP_ID IN HEADERS
      InitSharedRepo.initClinicGroupHeader(userGroup.id);
      // SETTING UP CLINIC GROUP PATIENTS SHARED AND EMR PROVIDER TO REDUX
      dispatch(
        _patientsShared(
          userGroup.patients_shared,
          userGroup.emr_provider,
          userGroup.split_statement,
          userGroup.is_multi_column_mapping,
          userGroup.consolidated_group_billing_enable,
          userGroup.billing_clinic_id,
          userGroup.show_only_billing_practice
        )
      );
      // SETTING UP GROUP_TYPE TO REDUX
      dispatch(_groupType(userGroup.group_type));
      // RESETTING THE GROUP STATE WHEN A GROUP IS SELECTED
      dispatch(_resetGroupState());
      handleLoader();
      // TO SHOW THE ALERT DIALOG WHEN THE GROUP IS CHANGED
      dispatch(_showMessageAlert(true));
    }
  };

  const renderStopTimerDialog = () => {
    return (
      openDialogs.stopTimerDialog && (
        <StopTimerDialog
          open={openDialogs.stopTimerDialog}
          onClose={handleCloseStopTimerDialog}
          onCancel={() => {
            // noting to do
          }}
          onSave={() => handleSwitchGroup(navigateToGroup)}
        />
      )
    );
  };

  // ** Ticket Stop Timer dialog rendering after the warning dialog is rendered based on save response --> start //
  const renderTicketStopTimerDialog = () => {
    return (
      <StopTicketTimerDialog
        open={openDialogs.stopTicketTimerDialog}
        onClose={(res: any) => {
          setOpenDialogs(p => ({
            ...p,
            stopTicketTimerDialog: false
          }));
          // refreshActivity()
        }}
        clinicGroupId={groupId as number}
        clinicId={localStorageData?.ticketPanelData?.clinicId}
        ticketId={localStorageData?.ticketPanelData?.ticketId}
      />
    );
  };
  // ** Ticket Stop Timer dialog rendering after the warning dialog is rendered based on save response --> end //

  const renderGroupsDropDown = (): React.ReactElement => {
    return (
      <div
        className={classes.dropDownWrapper}
        onClick={() => setToolTipOpen(false)}>
        <Tooltip
          open={toolTipOpen}
          aria-label="add"
          disableHoverListener
          title={
            <div className={classes.toolTip}>
              {t('TOP_NAV_COMMON.GROUP_DROPDOWN').toString()}
            </div>
          }
          placement="bottom">
          <Select
            input={<StyledSelectInput />}
            labelId="switch-practice-group"
            id="switch-practice-group"
            data-test-id="pcl-switchPracticeGroupComponent"
            value={[selectedGroup.name]}
            className={classes.userGroups}
            MenuProps={{
              MenuListProps: {
                disablePadding: true
              },
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center'
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'center'
              },
              getContentAnchorEl: null
            }}
            renderValue={() => {
              return (
                <span
                  onMouseLeave={() => setToolTipOpen(false)}
                  onMouseEnter={() => setToolTipOpen(true)}>
                  {selectedGroup?.name ?? ''}
                </span>
              );
            }}>
            <div className={classes.ClinicMenu}>
              {userGroups.map((userGroup: any, index: number) => (
                <MenuItem
                  key={userGroup.name}
                  value={userGroup.name}
                  onClick={() => {
                    // BEFORE CHANGING THE GROUP CHECK WHETHER THE CCM TIMER IS RUNNING OR NOT
                    // IF IT IS RUNNING SHOW THE WARNING DIALOG
                    if (isCCMTimerRunning) {
                      handleShowStopTimerWarningDialog();
                      setNavigateToGroup(userGroup);
                    } else if (isTicketTimerRunning) {
                      // switching between groups when timer is running //
                      handleShowSwitchGroupStopTicketTimerWarningDialog();
                    } else {
                      dispatch(
                        _ccmSinglePatientDetails(ccmPatientId, '', null, false)
                      );
                      handleSwitchGroup(userGroup);
                    }
                  }}>
                  <ListItemText primary={userGroup.name} />
                  <Radio checked={selectedGroup.id == userGroup.id} />
                </MenuItem>
              ))}
            </div>
          </Select>
        </Tooltip>
      </div>
    );
  };

  const renderTabs = (): React.ReactElement => {
    return (
      <StyledTabs
        style={{minHeight: '40px'}}
        value={tabValue}
        variant="scrollable"
        scrollButtons={'auto'}
        onChange={handleTabChange}
        aria-label="top app tabs">
        {tabs.map(item => {
          return <StyledTab label={item} key={item} />;
        })}
      </StyledTabs>
    );
  };

  // TODO : rendered profile avatar with text to be of custom theme
  const renderProfileAvatar = (): React.ReactElement => {
    return (
      <>
        <span className={classes.name}>{user?.full_name ?? ''}</span>
        <Tooltip title={t('TOP_NAV_COMMON.MY_PROFILE').toString()}>
          <IconButton
            className={classes.buttonPadding}
            ref={anchorRef}
            aria-controls="customized-menu"
            aria-haspopup="true"
            color="inherit"
            onClick={handleToggleProfile}>
            {/* <AccountCircle fontSize={'large'} className={classes.profileIcon} /> */}
            <Avatar className={classes.blue}>
              {HelperUtils.shortName(user?.first_name, user?.last_name)}
            </Avatar>
          </IconButton>
        </Tooltip>
        {renderPopover()}
      </>
    );
  };

  const clinicsOfGroup = useSelector((state: any) => state.clinics?.list ?? []);
  const renderCCMTimer = () => {
    const timer = (
      <Timer
        // patientId={0}
        ccmPatientId={ccmPatientId}
        groupId={id}
        isFromTopAppBar={true}
        handleParentTimeStart={handleParentTimeStart}
        patientName={patientName}
        patientAccountNumber={accountNumber}
        logoutStopTime={showLogoutStopTimerDialog}
        setShowLogoutStopTimerDialog={setShowLogoutStopTimerDialog}
        startTimerLabel={t('CCM.START_TIMER.CCM_START_TIMER')}
        stopTimerLabel={t('CCM.STOP_TIMER.TOP_STOP_CCM_TIMER')}
      />
    );
    if (
      groupId &&
      userPermissions &&
      userPermissions[groupId as number] &&
      userPermissions[groupId as number][AppPermissions.CCM.NAME] &&
      userPermissions[groupId as number]['group']
    ) {
      const patientShared =
        userPermissions[groupId as number]['group']['patients_shared'];
      const isCCMEnabled = userPermissions[groupId as number]['group']['ccm'];
      if (patientShared === true && isCCMEnabled === true) {
        return timer;
      } else if (
        patientShared === false &&
        clinicsOfGroup &&
        Array.isArray(clinicsOfGroup)
      ) {
        const flag = clinicsOfGroup.some(c => c.is_ccm_enabled === true);
        if (flag) return timer;
        return null;
      }
      return null;
    }
  };

  return (
    <AppBar className={[className].join(' ')} elevation={15}>
      <div
        className={[classes.toolbarStyle, classes.toolbar, classes.root].join(
          ' '
        )}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
        <Hidden smDown>
          <div
            className={`${classes.appIconWidth}`}
            onClick={() => {
              setTimeout(() => {
                history.push('');
                // make the redux params empty when clicked on logo explicitly
                dispatch(
                  _ccmSinglePatientDetails(ccmPatientId, '', null, false)
                );
              }, 500);
            }}>
            <MedopsLogo color={'white'} className={classes.appIconLogo} />
          </div>
        </Hidden>
        {/* <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={() => handleDrawerToggle()}
          className={classes.menuButton}>
          <MenuIcon />
        </IconButton> */}
        <div className={classes.tabsAndMenuView}>
          {tabs?.length > 0 && (
            <span>
              {
                // Menu drop down starts
                <Button
                  data-test-id="pcl-menuDropDownComponent"
                  className={classes.Menu}
                  onClick={handleMenuProfile}
                  ref={menuAnchorRef}>
                  <span className={classes.titleMenu}>
                    {t('TOP_NAV_COMMON.TABS.MENU')}
                  </span>
                  {!arrowUp && <ArrowDropDownIcon className={classes.Arrow} />}
                  {arrowUp && <ArrowDropUp className={classes.Arrow} />}
                </Button>
              }
            </span>
          )}
          <div className={classes.tabMargin}>{renderTabs()}</div>
          {renderMenuPopovers()}
        </div>
        {
          //  TODO update the condition
          userType !== UserTypes.ADMIN && renderCCMTimer()
          //  (
          //   <Timer
          //     patientId={0}
          //     ccmPatientId={ccmPatientId}
          //     groupId={id}
          //     clinicId={0}
          //     isFromTopAppBar={true}
          //     handleParentTimeStart={handleParentTimeStart}
          //     logoutStopTime={showLogoutStopTimerDialog}
          //     patientName={patientName}
          //     accountNumber={accountNumber}
          //   />
          // )
        }
        <div className={classes.iconWrapper}>
          {userType !== UserTypes.ADMIN && renderGroupsDropDown()}
          {groupType !== ORGANIZATION_GROUP_TYPES.BILLING_GROUP_VALUE
            ? userPermissions &&
              userType !== UserTypes.ADMIN &&
              Permission.hasIncomingSmsPermissions(
                userPermissions,
                AppPermissions.INCOMING_SMS.LIST,
                id
              ) && (
                <Tooltip title={t('TOP_NAV_COMMON.MESSAGES').toString()}>
                  <IconButton
                    aria-controls="customized-menu"
                    aria-haspopup="true"
                    color="inherit"
                    className={classes.notificationsIcon}
                    onClick={() => {
                      const messageObject = {
                        name: AppPermissions.INCOMING_SMS.NAME,
                        id: 'INCOMING_SMS',
                        route: `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.INCOMING_SMS}`,
                        label: (
                          <div className={classes.mainWrap}>
                            {t('TABS.INCOMING_SMS')}
                            <span className={classes.customBadge}>
                              <CustomBadge count={count} />
                            </span>
                          </div>
                        )
                      };
                      handleRoute(messageObject);
                      dispatch(
                        _ccmSinglePatientDetails(ccmPatientId, '', null, false)
                      );
                    }}>
                    <NotificationsNoneIcon />
                    <div className={classes.badgeWrapper}>
                      <CustomBadge count={count} />
                    </div>
                  </IconButton>
                </Tooltip>
              )
            : ''}

          {renderProfileAvatar()}
          {showStopTimerWarningDialog && (
            <WarningTimerDialog
              open={showStopTimerWarningDialog}
              onClose={closeStopTimerWarningDialog}
              onSave={handleStopTimer}
              titleHeader={t('CCM.WARNING.DIALOG_HEADER')}
              contentBody={
                <Trans
                  i18nKey={'CCM.WARNING.ALERT_LOGOUT_STOP_TIMER'}
                  values={{
                    patient_name: patientName
                  }}
                  components={[<strong key={'X'} />]}
                />
              }
              cancelBtnText={t('COMMON.NO')}
              confirmBtnText={t('COMMON.YES')}
            />
          )}
          {/** render stopTicketTimer Warning dialog while logging out of the application */}
          {showStopTicketTimerWarningDialog && (
            <WarningTimerDialog
              open={showStopTicketTimerWarningDialog}
              onClose={() => {
                handleCloseStopTicketTimerWarningDialog();
              }}
              onSave={() => {
                handleShowStopTicketTimerDialog();
              }}
              titleHeader={t(
                'TICKETING_SYSTEM.TIMER.WARNING_DIALOG.ALERT_HEADER'
              )}
              contentBody={
                <Trans
                  i18nKey={
                    'TICKETING_SYSTEM.TIMER.WARNING_DIALOG.ALERT_LOGOUT_STOP_TIMER'
                  }
                  values={{
                    patient_name: localStorageData?.ticketPanelData?.patientName
                  }}
                  components={[<strong key={'X'} />]}
                />
              }
              cancelBtnText={t('COMMON.NO')}
              confirmBtnText={t('COMMON.YES')}
            />
          )}
        </div>
      </div>
      {renderStopCCMTimerRunningWarningDialog()}
      {renderStopTimerDialog()}
      {/** render stopTicketTimer dialog  section */}
      {/** below is while switching groups this function executes */}
      {renderGroupSwitchTicketTimerWarningPrompt()}
      {/** below is to stop the ticket timer after the warning dialog or normally when
       * the user wants to stop the ticket timer this function executes */}
      {openDialogs.stopTicketTimerDialog && renderTicketStopTimerDialog()}
    </AppBar>
  );
};

const mapStateToProps = (state: any): any => {
  return {
    userGroups: state.auth.userGroups,
    user: state.auth.user,
    groupId: state.auth.groupId,
    userType: state.auth.userType,
    count: state.newMessages.count,
    userPermissions: state.auth.userPermissions
  };
};
export default connect(mapStateToProps, {
  logout: _logout
})(TopAppBar);
